module.exports = __webpack_public_path__ + "static/load-speed-146ea32ce3cd35da0108e5fe2a4e1957.png";